import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import api from '@survey/api'


@Component({
    components: {},
})

export default class SurveyReadQuestion extends Vue {
    @Prop({ type: Object }) value!: survey.SurveyQuestionDetail
    @Prop({ type: Boolean, default: false }) isStatistics!: boolean
    // 

    get typeString(): string {
        switch(this.value.questionInfo.questionType) {
            case 0: return this.$t('선택형').toString()
            case 1: return this.$t('선택형_복수선택').toString()
            case 2: return this.$t('서술형').toString()
            case 3: return this.$t('단답형').toString()
            default: return '';
        }
    } 

    setTitle(){
        return `${this.value.questionInfo.questionOrders.toString().length == 1 ? '0':''}${this.value.questionInfo.questionOrders}. ${this.value.questionInfo.questionText} `
    }
}
